module.exports = __webpack_public_path__ + "img/jiaoyu_beijingyoudian_suoluetu.6b3e7e20.png";